import { deleteJiraInitiativesUnlinkIssueSlice } from './@async/delete';
import { getInitiativesJiraIssueSlice } from './@async/get';
import { postInitiativesSyncJiraSlice } from './sync-jira/@async/post';
import { putJiraInitiativesLinkIssueSlice } from './@async/put';
import { initiativesJiraIssueAddSyncSlice } from './@sync/add';
import { initiativesJiraIssueRemoveSyncSlice } from './@sync/remove';
import { initiativesJiraIssueUpdateSlice } from './@sync/update';

export * from './sync-jira/actions';

export const addJiraIssue = initiativesJiraIssueAddSyncSlice.syncActionCreator;
export const removeJiraIssue = initiativesJiraIssueRemoveSyncSlice.syncActionCreator;
export const updateJireIssue = initiativesJiraIssueUpdateSlice.syncActionCreator;
export const { requestDeleteJiraInitiativesUnlinkIssue, resetDeleteJiraInitiativesUnlinkIssue } = deleteJiraInitiativesUnlinkIssueSlice.asyncActionCreators;
export const { requestGetInitiativeJiraIssues, resetGetInitiativeJiraIssues } = getInitiativesJiraIssueSlice.asyncActionCreators;
export const { requestPostInitiativesSyncJiraIssue, resetPostInitiativesSyncJiraIssue } = postInitiativesSyncJiraSlice.asyncActionCreators;
export const { requestPutJiraInitiativesLinkIssue, resetPutJiraInitiativesLinkIssue } = putJiraInitiativesLinkIssueSlice.asyncActionCreators;
